import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-laboratori-alimentari',
  imports: [CommonModule],
  templateUrl: './panificio.html',
  styleUrls: ['./panificio.scss'],
})
export class LaboratoriAlimentariComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Pulizia laboratori alimentari a Pescara | SAMI Pulizie',
      description:
        'Pulizia e sanificazione professionale per laboratori alimentari, panifici e pastifici a Pescara e provincia. Servizi conformi HACCP.',
      keywords:
        'pulizia laboratori alimentari Pescara, pulizia panifici, sanificazione pastifici, HACCP, controlli ASL, SAMI Pulizie',
      canonicalUrl: '/laboratori-alimentari',

      ogTitle: 'Pulizia laboratori alimentari a Pescara | SAMI Pulizie',
      ogDescription:
        'Servizi professionali per ambienti alimentari soggetti a controlli ASL e HACCP.',
      ogImage: '/assets/logo.png',
      ogType: 'website',

      twitterCard: 'summary_large_image',
      twitterTitle: 'Pulizia laboratori alimentari a Pescara | SAMI Pulizie',
      twitterDescription:
        'Pulizie professionali e sanificazioni HACCP per laboratori alimentari.',
      twitterImage: '/assets/logo.png',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Pulizia laboratori alimentari',
        description:
          'Pulizia e sanificazione professionale per laboratori alimentari, panifici e pastifici.',
        provider: {
          '@type': 'CleaningService',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/',
          logo: 'https://samipulizie.it/assets/logo.png',
        },
        areaServed: { '@type': 'AdministrativeArea', name: 'Pescara' },
        url: 'https://samipulizie.it/laboratori-alimentari',
      },
    });
  }

  navigateToPreventiviSito() {
    this.router.navigateByUrl('/preventivo');
  }
}
